import React from 'react'

export const NoCampaignsImage = props => {
  return (
    <svg
      width="240"
      height="183"
      viewBox="0 0 240 183"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_136_12527)">
        <path
          d="M240.877 116.8C241.114 113.223 241.01 109.633 240.549 106.074C238.393 89.3574 228.626 73.5964 214.247 62.4724C209.119 58.503 203.28 54.9502 199.945 49.7129C194.322 40.8921 194.748 30.7543 187.771 22.0438C180.787 13.3271 170.608 6.52161 159.132 3.03004C124.904 -7.3834 76.9887 9.57214 81.3072 45.7741C81.3212 45.9028 81.3421 46.0927 81.3561 46.3316C81.9282 53.8537 75.2097 60.1753 66.6493 60.3529C35.073 61.0084 7.892 82.3866 2.07348 109.461C-1.66601 126.876 4.45949 145.964 18.9639 158.282C29.7917 167.477 44.324 172.53 58.8634 175.997C88.0118 182.956 118.681 184.414 148.737 181.755C176.866 179.262 206.545 172.163 224.733 153.161C234.445 143.023 240.005 130.025 240.877 116.8Z"
          fill="white"
        />
        <path
          d="M146.478 114.4H142.565C142.279 114.401 141.995 114.346 141.73 114.237C141.465 114.128 141.223 113.968 141.02 113.766C140.817 113.564 140.656 113.324 140.545 113.059C140.435 112.794 140.378 112.511 140.377 112.224L141.73 106.925L134.319 108.908L135.946 115.29C137.66 138.663 106.897 141.221 105.731 115.906L86.6675 120.574V120.565L74.2203 123.276L82.5069 156.387L99.7887 152.213C102.172 156.821 103.918 160.019 103.918 160.019H157.23L146.478 114.4Z"
          fill="#2E3860"
        />
        <path
          d="M67.9297 158.95C88.9637 151.959 125.895 144.751 125.895 144.751L87.5788 121.649C87.5788 121.649 78.2455 123.121 69.1401 125.302"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45.0249 159C34.5863 157.201 37.5644 127.82 55.1127 101.858C62.9775 89.0245 65.2401 85.5372 71.2848 83.5408C73.6496 82.7609 76.1822 82.7624 78.8704 83.956C88.4287 88.2017 98.5867 92.6206 91.7837 94.5619C84.9807 96.5032 68.9246 109.755 68.9246 109.755C68.9246 109.755 69.0771 126.968 68.2289 133.242C67.6861 137.213 66.7519 141.119 65.4399 144.904"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M99.0138 81.3525C98.5474 88.4302 99.6022 97.2804 100.669 103.028"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M136.262 89.1982C138.129 89.3669 142.13 90.2975 141.479 95.1751C140.91 99.4428 137.115 99.4142 134.7 98.9398"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M133.495 105.655L135.952 115.293C137.616 138.042 108.492 141.074 105.881 117.848"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M129.164 90.2407L135.777 90.7798C135.777 90.7798 133.692 104.663 132.806 108.412C131.919 112.162 131.221 113.852 126.588 117.598C121.955 121.345 111.706 123.614 106.441 118.22C101.176 112.826 99.9423 101.833 99.9423 101.833C102.303 100.96 108.334 100.446 108.334 100.446"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M136.129 91.3623C136.129 91.3623 139.268 84.8583 140.192 79.5019C141.06 74.4677 138.421 69.4124 133.691 67.4939C129.732 65.8826 128.444 66.4066 128.444 66.4066C128.444 66.4066 130.796 62.2233 124.682 56.0626C123.614 54.9851 122.338 54.1369 120.931 53.5701C119.524 53.0033 118.016 52.7298 116.5 52.7662C109.02 52.965 106.692 59.2883 106.692 59.2883C106.692 59.2883 98.7167 44.5441 82.2835 53.2135C80.6283 54.0884 78.755 56.534 77.8566 58.1829C72.408 68.167 90.2466 80.059 99.5473 81.0213C109.758 82.0754 116.173 80.8045 119.294 78.0969C116.947 79.7217 121.121 94.6918 136.129 91.3623Z"
          fill="#2E3860"
        />
        <path
          d="M107.758 96.2204L107.276 105.9L110.605 104.815"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M117.957 89.7165C117.42 89.1119 116.73 88.6627 115.961 88.4159C115.191 88.169 114.369 88.1335 113.581 88.313"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M105.484 86.1805C105.484 86.1805 102.812 85.2679 101.963 87.4454"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M118.691 107.754C118.165 107.031 113.035 110.633 115.039 110.957C117.044 111.281 119.821 109.307 118.691 107.754Z"
          fill="#2E3860"
        />
        <path
          d="M97.1793 107.091L116.672 100.499C116.672 100.499 119.279 99.5047 119.187 96.1195C119.096 92.7342 114.842 91.4678 114.842 91.4678L94.0675 88.5328L97.1793 107.091Z"
          fill="#004360"
        />
        <path
          d="M76.3208 107.091L95.8131 100.499C95.8131 100.499 98.4223 99.5047 98.3305 96.1195C98.2387 92.7342 93.9834 91.4678 93.9834 91.4678L83.9348 92.1349L73.209 88.5328L76.3208 107.091Z"
          fill="#004360"
        />
        <path
          d="M102.959 98.0769C102.959 103.112 98.88 107.194 93.8495 107.194C88.819 107.194 84.7403 103.112 84.7403 98.0769C84.7403 93.0416 88.819 88.9603 93.8495 88.9603C98.88 88.9603 102.959 93.0416 102.959 98.0769Z"
          fill="#F9F9FF"
          stroke="#1A2547"
        />
        <path
          d="M81.9556 98.214C81.9556 103.249 77.8769 107.331 72.8464 107.331C67.8159 107.331 63.7372 103.249 63.7372 98.214C63.7372 93.1786 67.8159 89.0974 72.8464 89.0974C77.8769 89.0974 81.9556 93.1786 81.9556 98.214Z"
          fill="#F9F9FF"
          stroke="#1A2547"
        />
        <path
          d="M79.4911 82.3812C83.3583 79.648 90.7917 78.7279 92.4017 78.9674C93.9471 79.1978 93.0503 81.7533 88.4292 83.1628"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M81.7477 83.0764C86.4123 81.9319 94.6568 86.2749 95.9839 87.5444C97.4059 88.8997 93.5493 91.038 86.31 86.8321C86.31 86.8321 84.1883 85.3985 82.4745 85.5611"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M77.3859 83.2935C82.1841 82.2825 90.4831 86.4818 91.8237 87.7163C93.2798 89.0485 90.0621 90.4273 82.6491 86.293C82.6491 86.293 80.192 84.0297 78.4386 84.1896"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M72.1227 83.6583C76.5181 81.55 85.8685 86.4396 87.2904 87.798C88.7124 89.1563 84.8558 91.2901 77.6165 87.0857C77.6165 87.0857 75.4948 85.6521 73.7825 85.8147"
          fill="white"
        />
        <path
          d="M72.1227 83.6583C76.5181 81.55 85.8685 86.4396 87.2904 87.798C88.7124 89.1563 84.8558 91.2901 77.6165 87.0857C77.6165 87.0857 75.4948 85.6521 73.7825 85.8147"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M201.083 70.3474C204.571 69.3023 208.627 68.6653 213.341 68.5945C213.341 68.5945 215.133 75.2626 212.944 83.5962"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M201.021 84.653C201.918 79.9155 201.948 75.0492 201.111 70.3004"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M201.111 70.3005C199.686 62.1235 195.589 52.9466 187.067 43.1206C187.067 43.1206 177.963 48.0193 171.186 58.4356"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M163.974 103.49C163.974 103.49 155.729 69.7025 129.824 77.7831C129.824 77.7831 130.487 85.2102 134.153 92.6297"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M181.582 77.2624C178.559 66.688 171.143 54.9752 154.942 45.0062C154.942 45.0062 147.621 54.8999 144.735 68.6424"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M154.164 82.3569C155.14 77.0034 157.874 70.8353 163.47 63.9338C163.47 63.9338 201.372 81.5105 182.367 105.23"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M173.864 105.249C177.588 99.5598 191.004 81.8897 212.927 83.8654"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M212.921 83.8612C216.032 84.1521 219.103 84.7863 222.08 85.7526C222.08 85.7526 216.643 98.5873 204.12 106.454"
          stroke="#004360"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M195.955 142.283L202.005 115.191H205.653C205.939 115.192 206.222 115.141 206.486 115.042C206.75 114.943 206.991 114.798 207.193 114.614C207.396 114.43 207.556 114.212 207.666 113.972C207.776 113.731 207.833 113.473 207.834 113.213L208 108.982C208 108.721 207.944 108.463 207.834 108.222C207.724 107.981 207.563 107.762 207.361 107.578C207.158 107.394 206.918 107.248 206.653 107.149C206.389 107.05 206.105 106.999 205.819 107H142.345C142.059 106.999 141.776 107.05 141.512 107.149C141.247 107.249 141.007 107.395 140.805 107.579C140.602 107.763 140.442 107.982 140.332 108.222C140.223 108.463 140.166 108.722 140.166 108.982L140 113.213C140.001 113.473 140.057 113.731 140.167 113.971C140.277 114.212 140.438 114.43 140.64 114.614C140.843 114.797 141.083 114.943 141.347 115.042C141.611 115.141 141.894 115.192 142.179 115.191H146.081L157.053 160"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M186.479 139.979C184.743 137.491 183.414 134.838 185.078 134.127C187.367 133.15 187.335 135.616 190.786 137.972C194.236 140.327 197.468 140.768 200.89 145.049"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M186.595 140.347C180.704 137.145 172.15 136.96 170.097 137.052C168.845 137.107 168.415 138.169 169.363 139.508"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M183.823 143.673C177.853 140.536 169.346 139.362 167.177 139.532C165.38 139.673 165.359 141.976 168.23 144.28"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M182.404 147.68C176.951 145.239 170.612 144.09 168.766 144.191C166.79 144.299 166.716 147.343 170.326 150.139"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M182.146 151.726C177.532 149.809 172.94 148.757 171.462 148.934C168.552 149.284 170.981 154.487 184.793 158.637"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M184.797 158.637C213.212 166.394 211.36 141.771 186.779 140.235"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M223.649 160.462H16.8421"
          stroke="#2E3860"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_136_12527">
          <rect width="240" height="183" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
